import { render, staticRenderFns } from "./xeGoalCard.vue?vue&type=template&id=a56858c4&scoped=true"
import script from "./xeGoalCard.vue?vue&type=script&lang=js"
export * from "./xeGoalCard.vue?vue&type=script&lang=js"
import style0 from "./xeGoalCard.vue?vue&type=style&index=0&id=a56858c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56858c4",
  null
  
)

export default component.exports